import { InferOutput, literal, object } from 'valibot'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { EntityTypeMeta, entityTypeDefaults } from '../../EntityTypeMeta'
import { HasXYSchema } from '../../has_xy'
import { BaseEntitySchema } from '../BaseEntity'
import { ELEVATION_LAND_FLOOR_DEFAULT } from '../EntityElevation/elevation_consts'
import { EntityElevationSchema } from '../EntityElevation/EntityElevation.type'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'

const entDefaults = {
  etype_id: EntityTypeId.Swamp,
  layer_id: EntityLayerId.TerrainL1,
  floor_e: -1,
  water_e: ELEVATION_LAND_FLOOR_DEFAULT,
} as const

export const SwampEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.Swamp),
  layer_id: literal(EntityLayerId.TerrainL1),
  id: EntityIdSchema,
  floor_e: EntityElevationSchema,
  water_e: EntityElevationSchema,
  ...HasXYSchema.entries,
})

export type SwampEntity = InferOutput<typeof SwampEntitySchema>

/**
 * Wetland area with standing water and dominated by woody plants and mosses.
 */
export const SwampEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.Swamp,
  dname: 'Swamp',
  layer_id: EntityLayerId.TerrainL1,
  group_id: EntityTypeGroupId.Terrain,
  defense: 0,
  entDefaults,
}

export function createSwampEntity(id: number, x: number, y: number): SwampEntity {
  return {
    ...entDefaults,
    heading: 0,
    id,
    x,
    y,
  }
}
